const KEY = "truestream_anon_count";
const LIMIT = 3;

/** How many anonymous fact-checks the current browser has burned. */
export function getAnonCount() {
  try {
    return Number.parseInt(window.localStorage.getItem(KEY) || "0", 10) || 0;
  } catch {
    return 0;
  }
}

/** Bump the counter by one. Returns the new total. */
export function bumpAnonCount() {
  const next = getAnonCount() + 1;
  try {
    window.localStorage.setItem(KEY, String(next));
  } catch {
    // storage disabled — no cap enforced
  }
  return next;
}

/** True if this anonymous browser has already used all its free checks. */
export function anonQuotaExhausted() {
  return getAnonCount() >= LIMIT;
}

/** How many free checks remain (0..LIMIT). */
export function anonQuotaRemaining() {
  return Math.max(0, LIMIT - getAnonCount());
}

export const ANON_LIMIT = LIMIT;
